import { createTheme, Direction } from "@mui/material/styles";

export const createAppTheme = (direction: Direction) =>
  createTheme({
    direction,
    typography: {
      fontFamily: "Noto Sans",
      fontWeightMedium: 400,
      allVariants: {
        color: "#1b232a",
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          startIcon: {
            marginInlineEnd: "8px",
            marginInlineStart: 0,
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            display: "block",
            alignItems: "center",
            gap: "8px",
          },
        },
      },
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            verticalAlign: "middle",
          },
        },
      },
      MuiDialogActions: {
        styleOverrides: {
          root: {
            gap: "12px",
            justifyContent: "flex-end",
          },
        },
      },
    },
  });
